export function tableTemplate(body) {
    const html = `
        <div class="listing listing-table-responsive">
            <table>
                <thead>
                    <tr>
                        <th style="width: 10px;"></th>
                        <th style="width: 10px;">#</th>
                        <th style="width: 100%;">Name</th>
                        <th style="width: 10px;"></th>
                        <th style="width: 10px;">Latest</th>
                        <th style="width: 10px;">#&nbsp;led</th>
                    </tr>
                </thead>
                <tbody>
                    ${body}
                </tbody>
            </table>
        </div>
    `;
    return html;
}
